export type Maybe<T> = T | undefined
export type InputMaybe<T> = T | undefined
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  DateTime: { input: string; output: string }
  JSON: { input: Record<string, unknown>; output: Record<string, unknown> }
}

/** Create a new workflow definition. Workflows are created inactive and must be activated via updateWorkflow(active: true) after the graph is valid. */
export type CreateWorkflowInput = {
  /** Opaque JSON blob for the frontend builder (preserved by the engine, never interpreted). Stores UI-only fields like node labels, editor state, and unsupported-node configs so round-trips are lossless. */
  builderJson?: InputMaybe<Scalars['String']['input']>
  /** The workflow graph edges connecting nodes */
  edges: Array<WorkflowEdgeInput>
  /** Location this workflow belongs to */
  locationId: Scalars['String']['input']
  /** Human-readable workflow name */
  name: Scalars['String']['input']
  /** The workflow graph nodes */
  nodes: Array<WorkflowNodeInput>
  /** JSON settings object (quiet hours, etc.) */
  settings?: InputMaybe<Scalars['String']['input']>
  /** When this workflow should enroll contacts */
  trigger: WorkflowTriggerInput
  triggerStartDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type Event = {
  __typename?: 'Event'
  action: Scalars['String']['output']
  actor?: Maybe<Scalars['JSON']['output']>
  createdDate: Scalars['DateTime']['output']
  data: Scalars['JSON']['output']
  eventDate: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  /** Intent attached to a journey change, or the source contact for a merge link. */
  journeyMeta?: Maybe<Scalars['JSON']['output']>
  locationId: Scalars['String']['output']
  note?: Maybe<Scalars['String']['output']>
  orgId: Scalars['String']['output']
  source: Scalars['String']['output']
  type: Scalars['String']['output']
  typeId: Scalars['String']['output']
  updatedDate: Scalars['DateTime']['output']
  version: Scalars['Int']['output']
  workflowIds: Array<Scalars['String']['output']>
  workspaceId: Scalars['String']['output']
}

export type EventListResult = {
  __typename?: 'EventListResult'
  hits: Array<Event>
  page: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type Query = {
  __typename?: 'Query'
  _?: Maybe<Scalars['String']['output']>
}

/** Result of manually triggering a workflow on a contact */
export type TriggerWorkflowOnContactResult = {
  __typename?: 'TriggerWorkflowOnContactResult'
  contactId: Scalars['ID']['output']
  success: Scalars['Boolean']['output']
  workflowId: Scalars['ID']['output']
  /** Type of workflow triggered: "ai" or "multi_step" */
  workflowType: Scalars['String']['output']
}

/** Update an existing workflow. Only provided fields are changed. Setting active=true validates the graph before activating. */
export type UpdateWorkflowInput = {
  /** Activate or deactivate. Activation validates the graph (nodes must exist, edges must reference valid nodes). */
  active?: InputMaybe<Scalars['Boolean']['input']>
  /** Opaque JSON blob for the frontend builder (preserved, never interpreted by engine). */
  builderJson?: InputMaybe<Scalars['String']['input']>
  edges?: InputMaybe<Array<WorkflowEdgeInput>>
  /** Change the workflow's location (only while inactive) */
  locationId?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  nodes?: InputMaybe<Array<WorkflowNodeInput>>
  /** Pause or unpause a running workflow. While paused, patients stay at their current step, no steps run, and no new patients enroll. Unpausing resumes patients from where they stopped. Pausing does not end any run; use active=false to end them. */
  paused?: InputMaybe<Scalars['Boolean']['input']>
  /** Why the workflow is being paused. Required when paused is set to true. */
  pausedReason?: InputMaybe<Scalars['String']['input']>
  /** JSON settings object (quiet hours, etc.) */
  settings?: InputMaybe<Scalars['String']['input']>
  trigger?: InputMaybe<WorkflowTriggerInput>
  triggerStartDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type Workflow = {
  __typename?: 'Workflow'
  active: Scalars['Boolean']['output']
  /** Opaque frontend builder state (preserved by engine, never interpreted) */
  builderJson?: Maybe<Scalars['JSON']['output']>
  /** Message category: transactional or marketing */
  category?: Maybe<Scalars['String']['output']>
  createdDate: Scalars['DateTime']['output']
  /** Array of workflow edges (typed JSON) */
  edgesJson: Scalars['JSON']['output']
  id: Scalars['ID']['output']
  locationId?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  /** Array of workflow nodes (typed JSON) */
  nodesJson: Scalars['JSON']['output']
  orgId: Scalars['String']['output']
  /** Whether the workflow is paused. A pause holds every patient at their current step, runs no steps, and blocks new enrollment until the workflow is unpaused. Set by staff from the builder or by the engine when a step cannot run due to the location's setup. */
  paused: Scalars['Boolean']['output']
  /** When the workflow was paused. */
  pausedDate?: Maybe<Scalars['DateTime']['output']>
  /** The node whose setup failure paused the workflow, when the engine paused it. Empty for a manual staff pause. */
  pausedNodeId?: Maybe<Scalars['String']['output']>
  /** Why the workflow was paused: "manual" for a staff pause, or the setup failure reason code for an engine pause. */
  pausedReason?: Maybe<Scalars['String']['output']>
  /** Optional workflow settings */
  settingsJson?: Maybe<Scalars['JSON']['output']>
  /** Trigger configuration: { event, filters, reenrollment } */
  triggerJson: Scalars['JSON']['output']
  triggerStartDate: Scalars['DateTime']['output']
  updatedDate: Scalars['DateTime']['output']
  version: Scalars['Int']['output']
  workspaceId: Scalars['String']['output']
}

/** A directed connection between two nodes. sourceHandle determines which outcome port to follow (e.g. "done", "replied", "no_reply", "answered", "voicemail", "no_answer", "timeout"). */
export type WorkflowEdgeInput = {
  /** Unique edge ID (client-generated) */
  id: Scalars['String']['input']
  /** Source node ID */
  source: Scalars['String']['input']
  /** Output handle on the source node: "done" for action/wait nodes, or a named outcome for branch nodes ("replied", "no_reply", "answered", "voicemail", "no_answer", "timeout"). A Wait node with early-exit conditions uses "conditions_met" and "timed_out" instead of "done". */
  sourceHandle: Scalars['String']['input']
  /** Target node ID */
  target: Scalars['String']['input']
  /** Input handle on the target node (usually "in") */
  targetHandle: Scalars['String']['input']
}

export type WorkflowListResult = {
  __typename?: 'WorkflowListResult'
  hits: Array<Workflow>
  page: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

/** A single node in the workflow graph. The 'type' field determines which config fields are required. Unused fields for a given type should be omitted or null. */
export type WorkflowNodeInput = {
  /** edit_task: set the task archived flag. Archiving removes it from the Tasks list without closing it. */
  archived?: InputMaybe<Scalars['Boolean']['input']>
  /** User ID to assign the task to */
  assigneeId?: InputMaybe<Scalars['String']['input']>
  /** The brief that sets the agent's goal for this conversation. The workflow supplies only this; the prompt and voice are shared. */
  brief?: InputMaybe<Scalars['String']['input']>
  /** If true, adjusts the resume time to fall within the contact's location business hours */
  businessHoursOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** What to do when the agent is already engaged on the thread: "take_over" (replace the active brief and send) or "do_nothing" (stand down). */
  busyBehavior?: InputMaybe<Scalars['String']['input']>
  /** For "do_nothing": if the agent's last message is older than this many days, the prior engagement has lapsed and the workflow takes over anyway. Unset means always stand down. */
  busyLimitDays?: InputMaybe<Scalars['Int']['input']>
  /** Delivery channel: "app", "email", or "both" */
  channel?: InputMaybe<Scalars['String']['input']>
  /** JSON array of conditions: [{ id, label?, filters: [{ attribute, operator, value }], filterLogic?, source? }]. source is "contact" (default), "activity", "appointment" (the appointment the run enrolled from — branch on an appointment field), or "thread" (the contact's SMS thread — e.g. filter thread.aiEnabled to skip a handoff when the agent is already engaged). Each condition's id is used as the sourceHandle for outgoing edges. A fallback edge uses sourceHandle "default". */
  conditions?: InputMaybe<Scalars['String']['input']>
  /** log_follow_up: Connected value — "yes", "no", or "from_direction" (default: yes when the comm log was received, no for sent, unknown direction, or no comm log). */
  connected?: InputMaybe<Scalars['String']['input']>
  /** Note content text */
  content?: InputMaybe<Scalars['String']['input']>
  /** Task description/body */
  description?: InputMaybe<Scalars['String']['input']>
  /** Absolute due date (ISO string). Takes precedence over dueInDays. */
  dueDate?: InputMaybe<Scalars['String']['input']>
  /** Number of days from now for the task due date */
  dueInDays?: InputMaybe<Scalars['Int']['input']>
  /** Duration to pause, e.g. "30m", "2h", "1d" */
  duration?: InputMaybe<Scalars['String']['input']>
  /** For a Wait node: optional early-exit conditions on the run's contact, as a JSON object { filters: [{ attribute, operator, value }], filterLogic? }. Same shape as a Filter step. When set, the Wait ends early with sourceHandle "conditions_met" the moment the contact matches (checked at wait start, on contact changes, and once a day), otherwise "timed_out" when the duration elapses. Omit for a plain single-path Wait. */
  earlyExit?: InputMaybe<Scalars['String']['input']>
  /** Days until the paperwork link expires (default 14) */
  expiresInDays?: InputMaybe<Scalars['Int']['input']>
  /** JSON object of field names to values to set on the contact. Use null to clear a field. */
  fields?: InputMaybe<Scalars['String']['input']>
  /** log_follow_up: whether the follow-up date is the comm log date ("comm_log", default) or the time the step runs ("now"). With no comm log on the run, both are the time the step runs. */
  followUpDate?: InputMaybe<Scalars['String']['input']>
  /** send_email: the HTML email body. Supports {{token}} templating. */
  html?: InputMaybe<Scalars['String']['input']>
  /** Unique node ID (client-generated, used in edge references) */
  id: Scalars['String']['input']
  /** Message text to send, or the notification message body. */
  message?: InputMaybe<Scalars['String']['input']>
  /** log_follow_up: the follow-up note text. Comm log event data is available as {{commLog.channelLabel}}, {{commLog.direction}}, {{commLog.subject}}, {{commLog.note}}, {{commLog.date}}. Empty inserts nothing. */
  note?: InputMaybe<Scalars['String']['input']>
  /** edit_task: when true, only edit the branch task if its status is open; otherwise the step no-ops and its path continues. */
  onlyIfOpen?: InputMaybe<Scalars['Boolean']['input']>
  /** log_follow_up: the user to own the follow-up. A deactivated or missing user leaves the follow-up unowned. */
  ownerId?: InputMaybe<Scalars['String']['input']>
  /** PaperworkTemplate ID to send to the enrolled contact's patient */
  paperworkTemplateId?: InputMaybe<Scalars['String']['input']>
  /** Pipeline ID to set the stage on */
  pipelineId?: InputMaybe<Scalars['String']['input']>
  /** Canvas position (x, y) */
  position: WorkflowNodePositionInput
  /** What to do when the send falls in quiet hours (20:00–08:00 location time): "hold" (default, sends at 08:00) or "skip" (don't send). */
  quietHoursAction?: InputMaybe<Scalars['String']['input']>
  /** User IDs to notify */
  recipients?: InputMaybe<Array<Scalars['String']['input']>>
  /** For a Wait for reply node: JSON array of named reply options [{ id, label, keywords: [String] }]. Each option's id is the sourceHandle of its outgoing edge; a reply matching one of its keywords (trim + lowercase, exact) takes that exit. Any other inbound text takes sourceHandle "other_reply"; the window ending with no reply takes "no_reply". Omit or pass an empty array for the original two exits, "replied" and "no_reply". */
  replyOptions?: InputMaybe<Scalars['String']['input']>
  /** Staff phone number to ring and bridge to the contact. Caller ID is always the location primary tracking number. */
  ringNumber?: InputMaybe<Scalars['String']['input']>
  /** Role ID to assign the task to. A task has a user or a role, not both. */
  roleId?: InputMaybe<Scalars['String']['input']>
  /** Stage name to set */
  stage?: InputMaybe<Scalars['String']['input']>
  /** edit_task: new task status, "open" or "closed". An edit_task close leaves completedByUserId empty; a reopen clears it. */
  status?: InputMaybe<Scalars['String']['input']>
  /** Stop the run (without taking the no-reply path) once a person is handling this patient: a staff member replies, someone takes the thread over from the agent, or another workflow's brief supersedes this one. Unset defaults to on. An opt-out always ends the run regardless. */
  stopOnHumanTakeover?: InputMaybe<Scalars['Boolean']['input']>
  /** send_email: the email subject. Supports {{token}} templating. */
  subject?: InputMaybe<Scalars['String']['input']>
  /** Tags to add or remove */
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  /** Target entity: "contact" (default) or "activity" */
  target?: InputMaybe<Scalars['String']['input']>
  /** Max time to wait for the event before timing out, e.g. "24h", "7d" */
  timeout?: InputMaybe<Scalars['String']['input']>
  /** Task title */
  title?: InputMaybe<Scalars['String']['input']>
  /** Which phone field to send to: "cellPhone", "homePhone", "workPhone". Defaults to first available. */
  toField?: InputMaybe<Scalars['String']['input']>
  /** Determines the node's behavior and which config fields are relevant */
  type: WorkflowNodeType
  /** User ID to assign as contact owner */
  userId?: InputMaybe<Scalars['String']['input']>
  /** Optional TTS whisper message played to the staff member before bridging. Supports {{contact.*}} and {{activity.*}} template variables. */
  whisperMessage?: InputMaybe<Scalars['String']['input']>
}

/** Canvas position for the node (used by the frontend builder, preserved by the backend) */
export type WorkflowNodePositionInput = {
  x: Scalars['Int']['input']
  y: Scalars['Int']['input']
}

/** The type of action or control a workflow node performs */
export enum WorkflowNodeType {
  AddTags = 'ADD_TAGS',
  AssignOwner = 'ASSIGN_OWNER',
  Branch = 'BRANCH',
  ConfirmAppointment = 'CONFIRM_APPOINTMENT',
  CreateNote = 'CREATE_NOTE',
  CreateTask = 'CREATE_TASK',
  EditActivity = 'EDIT_ACTIVITY',
  EditContact = 'EDIT_CONTACT',
  EditTask = 'EDIT_TASK',
  InitiateAgent = 'INITIATE_AGENT',
  InitiateCall = 'INITIATE_CALL',
  LogFollowUp = 'LOG_FOLLOW_UP',
  RemoveFromPipeline = 'REMOVE_FROM_PIPELINE',
  RemoveTags = 'REMOVE_TAGS',
  SendEmail = 'SEND_EMAIL',
  SendNotification = 'SEND_NOTIFICATION',
  SendPaperwork = 'SEND_PAPERWORK',
  SendSms = 'SEND_SMS',
  SetPipelineStage = 'SET_PIPELINE_STAGE',
  Wait = 'WAIT',
  WaitForCallResult = 'WAIT_FOR_CALL_RESULT',
  WaitForReply = 'WAIT_FOR_REPLY',
}

/** How the workflow handles a contact that triggers again while already enrolled */
export enum WorkflowReenrollmentPolicy {
  AllowMultiple = 'ALLOW_MULTIPLE',
  Ignore = 'IGNORE',
  Restart = 'RESTART',
}

export type WorkflowRun = {
  __typename?: 'WorkflowRun'
  activityId?: Maybe<Scalars['String']['output']>
  branchTaskId?: Maybe<Scalars['String']['output']>
  contactId?: Maybe<Scalars['String']['output']>
  createdDate: Scalars['DateTime']['output']
  currentNodeId: Scalars['String']['output']
  enrolledByUserId?: Maybe<Scalars['String']['output']>
  enrollmentEventId?: Maybe<Scalars['String']['output']>
  exitReason?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  locationId?: Maybe<Scalars['String']['output']>
  orgId: Scalars['String']['output']
  parentRunId?: Maybe<Scalars['String']['output']>
  resumeAt?: Maybe<Scalars['DateTime']['output']>
  sentPaperworkId?: Maybe<Scalars['String']['output']>
  sourceId?: Maybe<Scalars['String']['output']>
  sourceType?: Maybe<Scalars['String']['output']>
  startedAt: Scalars['DateTime']['output']
  status: Scalars['String']['output']
  updatedDate: Scalars['DateTime']['output']
  version: Scalars['Int']['output']
  waitingFor?: Maybe<Scalars['String']['output']>
  workflowId: Scalars['String']['output']
  workspaceId: Scalars['String']['output']
}

export type WorkflowRunEvent = {
  __typename?: 'WorkflowRunEvent'
  contactId?: Maybe<Scalars['String']['output']>
  createdDate: Scalars['DateTime']['output']
  eventId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  nodeId: Scalars['String']['output']
  nodeType: Scalars['String']['output']
  orgId: Scalars['String']['output']
  outputJson?: Maybe<Scalars['JSON']['output']>
  runId?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
  timestamp: Scalars['DateTime']['output']
  updatedDate: Scalars['DateTime']['output']
  version: Scalars['Int']['output']
  workflowId?: Maybe<Scalars['String']['output']>
  workspaceId: Scalars['String']['output']
}

export type WorkflowRunEventListResult = {
  __typename?: 'WorkflowRunEventListResult'
  hits: Array<WorkflowRunEvent>
  page: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type WorkflowRunListResult = {
  __typename?: 'WorkflowRunListResult'
  hits: Array<WorkflowRun>
  page: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

/** The entity lifecycle event that triggers workflow enrollment */
export enum WorkflowTriggerEvent {
  ActivityCreated = 'ACTIVITY_CREATED',
  ActivityDateReached = 'ACTIVITY_DATE_REACHED',
  ActivityUpdated = 'ACTIVITY_UPDATED',
  AppointmentCreated = 'APPOINTMENT_CREATED',
  AppointmentDateReached = 'APPOINTMENT_DATE_REACHED',
  AppointmentUpdated = 'APPOINTMENT_UPDATED',
  CallCreated = 'CALL_CREATED',
  CallDateReached = 'CALL_DATE_REACHED',
  CallFinishedProcessing = 'CALL_FINISHED_PROCESSING',
  CallUpdated = 'CALL_UPDATED',
  CommLogCreated = 'COMM_LOG_CREATED',
  ContactCreated = 'CONTACT_CREATED',
  ContactDateReached = 'CONTACT_DATE_REACHED',
  ContactUpdated = 'CONTACT_UPDATED',
  FormCreated = 'FORM_CREATED',
  FormDateReached = 'FORM_DATE_REACHED',
  FormUpdated = 'FORM_UPDATED',
  MessageCreated = 'MESSAGE_CREATED',
  MessageDateReached = 'MESSAGE_DATE_REACHED',
  PaperworkCompleted = 'PAPERWORK_COMPLETED',
  TaskCreated = 'TASK_CREATED',
  TaskDateReached = 'TASK_DATE_REACHED',
  TaskUpdated = 'TASK_UPDATED',
  TreatmentPlanClosed = 'TREATMENT_PLAN_CLOSED',
  TreatmentPlanCreated = 'TREATMENT_PLAN_CREATED',
  TreatmentPlanProcedureBooked = 'TREATMENT_PLAN_PROCEDURE_BOOKED',
  TreatmentPlanProcedureBrokenBooking = 'TREATMENT_PLAN_PROCEDURE_BROKEN_BOOKING',
  TreatmentPlanProcedureCompleted = 'TREATMENT_PLAN_PROCEDURE_COMPLETED',
  TreatmentPlanProcedurePresented = 'TREATMENT_PLAN_PROCEDURE_PRESENTED',
  TreatmentPlanUpdated = 'TREATMENT_PLAN_UPDATED',
}

/** A single filter condition evaluated against the triggering entity. All filters must match (AND logic). */
export type WorkflowTriggerFilterInput = {
  /** Dot-notation path on the entity to evaluate, e.g. "tags", "type", "leadStatus" */
  attribute: Scalars['String']['input']
  /** Comparison operator: in, not_in, exactly, not_exactly, contains, not_contains, attribute_exists, attribute_not_exists, greater_than, greater_equal_than, lesser_than, between, in_the_past */
  operator: Scalars['String']['input']
  /** The value to compare against. For array operators (in, not_in, between), pass a JSON-encoded array string. */
  value?: InputMaybe<Scalars['String']['input']>
}

/** Defines when a workflow enrolls contacts. Combines an event type, filter conditions, and a re-enrollment policy. */
export type WorkflowTriggerInput = {
  /** The entity lifecycle event that fires this trigger */
  event: WorkflowTriggerEvent
  /** How to combine change filters: "and" (all must match, default) or "or" (any must match) */
  filterLogic?: InputMaybe<Scalars['String']['input']>
  /** Change conditions — evaluated against the Event (field changed to X). AND logic by default. */
  filters: Array<WorkflowTriggerFilterInput>
  /** What happens if a contact triggers this workflow while already enrolled: ignore (skip), restart (cancel + re-enroll), allow_multiple (run in parallel) */
  reenrollment?: WorkflowReenrollmentPolicy
  /** When true, skip enrollment for activities that have no linked contacts (unknown callers, unmatched forms) */
  requireContactMatch?: InputMaybe<Scalars['Boolean']['input']>
  /** How to combine state filters: "and" (all must match, default) or "or" (any must match) */
  stateFilterLogic?: InputMaybe<Scalars['String']['input']>
  /** State conditions — evaluated against the live source record at enrollment time (record currently is X). AND logic by default. */
  stateFilters?: InputMaybe<Array<WorkflowTriggerFilterInput>>
}
